import * as React from 'react';
import { IconPlus16 } from '@cian/ui-kit';
import * as styles from './CreateFolderButton.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CreateFolderButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/_jsxs("button", {
    className: styles['button'],
    onClick: onClick,
    children: [/*#__PURE__*/_jsx("span", {
      className: styles['icon'],
      children: /*#__PURE__*/_jsx(IconPlus16, {})
    }), /*#__PURE__*/_jsx("span", {
      children: "\u041D\u043E\u0432\u0430\u044F \u043F\u043E\u0434\u0431\u043E\u0440\u043A\u0430"
    })]
  });
}